import { axios } from "@/utils/request";

// 搜索接口
export function search(page, pageSize, search) {
  return axios({
    url: `/home/search/${page}/${pageSize}/${search}`,
    method: "GET"
  });
}

// 搜索框列表
export function searchList(search) {
  return axios({
    url: `/home/search/${search}`,
    method: "GET"
  });
}

// 查询首页一级学科权限
export function checkUserAuth() {
  return axios({
    url: `/home/checkUserAuth`,
    method: "GET"
  });
}

// 查询一级、二级学科     查一级传0  查二级传一级id
export function queryCategoryName(parentId) {
  return axios({
    url: `/category/query/Category/${parentId}`,
    method: "GET"
  });
}

// 查询一级、二级学科     查一级传0  查二级传一级id
export function getHomeDetails(firSubId) {
  return axios({
    url: `/home/${firSubId}`,
    method: "GET"
  });
}

// 查询用户信息
export function getUserInfo() {
  return axios({
    url: `/home/query/userInfo`,
    method: "GET"
  });
}

// 查询一级学科、二级学科详情
export function queryOneCategory(catId) {
  return axios({
    url: `/category/queryOneCategory/${catId}`,
    method: "GET"
  });
}

// 查询课程详情
export function getCourseDetails(catId, page, pageSize) {
  return axios({
    url: `/category/queryCourse/list/${catId}/${page}/${pageSize}`,
    method: "GET"
  });
}

// 查询课件信息
export function querySlidesInfo(slideId) {
  return axios({
    url: `/slides/queryInfo/${slideId}`,
    method: "GET"
  });
}

// 删除课件
export function deleteSlides(slidesId) {
  return axios({
    url: `/slides/delete/${slidesId}`,
    method: "DELETE"
  });
}

// 获取web预览文件地址
export const getViewUrlWebPath = (params) => {
  return axios({
    url: "/v1/api/file/getViewUrlWebPath",
    method: "GET",
    params: params,
    baseURL: "https://www.ljserver.cn/wps"
  });
};

// 获取wps签名
export function getWpsUtilsPreview(data) {
  return axios({
    url: "/utils/preview/wps",
    method: "POST",
    data
  });
}

// 获取永中云签名
export function getUtilsPreview(data) {
  return axios({
    url: "/utils/preview",
    method: "POST",
    data
  });
}

// 查询地址栏
export function queryPath(courseId) {
  return axios({
    url: `/category/query/crumb/${courseId}`,
    method: "GET"
  });
}

// 获取二维码唯一id
export function getQRCode(params) {
  return axios({
    url: "/home/login/getQR",
    method: "POST",
    params
  });
}

// 校验是否超过使用人数
export function handleVerifyAuthCount() {
  return axios({
    url: `utils/auth/count`,
    method: "POST"
  });
}
